import(/* webpackMode: "eager", webpackExports: ["CustomerFirstAccessForm"] */ "/app/src/shared/components/forms/auth/customer/customer-first-access-form.component.tsx");
